import React from "react";

const Message=(props)=>(
   <h1> {props.title}</h1>
)

export default Message;
